<template>
  <div class="body">
    <span class="header-icon">
      <font-awesome-icon :icon="['fas', 'info-circle']" />
    </span>
    <h2>
      {{ $t('actionList.actionDetails.details') }}:
      {{ dataAction ? dataAction.controlId : '-' }} -
      {{ dataAction ? dataAction.name : '-' }}
    </h2>
    <div class="row d-flex mt-3 col-12">
      <div class="col-3 d-flex p-0">
        <input
          type="text"
          class="form-control"
          id="input-answer"
          :placeholder="$t('actionList.actionDetails.placeholderSearch')"
          v-model="filter"
          @keyup="searchByFilter"
        />
        <button class="btn btn-outline-primary" @click="cleanFilter">
          {{ $t('actionList.actionDetails.cleanInput') }}
        </button>
      </div>
      <div class="ml-3 col-2 p-0">
        <b-form-select
          v-model="actionDetailsStatus"
          :options="actionDetailsOptions"
          @change="changeStatus"
        >
        </b-form-select>
      </div>
    </div>

    <b-table
      striped
      responsive
      id="details-table"
      class="mt-4"
      :items="actionDetailsItems"
      :fields="fields"
      :busy="loading"
    >
      <template v-slot:table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner type="grow" class="align-middle"></b-spinner>
        </div>
      </template>

      <template v-slot:cell(name)="row">
        {{ row.item.theName ? row.item.theName : '-' }}
      </template>

      <template v-slot:cell(email)="row">
        {{ row.item.theEmail ? row.item.theEmail : '-' }}
      </template>

      <template v-slot:cell(phone)="row">
        {{ row.item.thePhone ? row.item.thePhone : '-' }}
      </template>

      <template v-slot:cell(date)="row">
        {{ dateFormat(new Date(row.item.createdAt)) }}
      </template>

      <template v-slot:cell(days)="row">
        <span v-if="row.item.status === 'enviado'">
          {{ setDifferenceInDays(new Date(row.item.createdAt)) }}
        </span>
        <span v-else> - </span>
      </template>

      <template v-slot:cell(channel)="row">
        {{ row.item.channel === 'emailsms' ? 'ambos' : row.item.channel }}
      </template>

      <template v-slot:cell(emailStatus)="row">
        <div :class="`flag-status flag-status-${returnColorStatusEmail(row.item.validEmail)}`">
          {{ verifyEmail(row.item).toUpperCase() }}
        </div>
      </template>

      <template v-slot:cell(phoneStatus)="row">
        <div
          :class="`flag-status flag-status-${returnColorStatusPhone(row.item.validPhone)}`"
        >
          {{ verifyPhone(row.item).toUpperCase() }}
        </div>
      </template>

      <template v-slot:cell(status)="row">
        <div :class="`flag-status flag-status-${row.item.status}`">
          {{ returnTranslateStatus(row.item.status.toUpperCase()) }}
        </div>
      </template>
    </b-table>
    <div v-show="!loading" class="pagination-area-details">
      <paginate
        :pageCount="Math.ceil(total / limit)"
        v-model="page"
        :clickHandler="loadTableInfo"
        :prevText="'‹'"
        :nextText="'›'"
        :activeClass="'active'"
        :containerClass="'pagination b-pagination'"
        :pageClass="'page-item'"
      >
      </paginate>
    </div>

    <div class="footer">
      <go-back-button />

      <div>
        <button
          style="padding: 0; border: none; background: none; margin-right: 10px"
          :title="`${this.$t('actionList.actionDetails.titleExportCSV')}`"
          @click="download('csv')"
          :disabled="loadingDownloadButtons"
        >
          <span class="xls">
            <i class="fas fa-file-csv"></i>
          </span>
        </button>

        <button
          style="padding: 0; border: none; background: none"
          :title="`${this.$t('actionList.actionDetails.titleExportXLS')}`"
          @click="download('xlsx')"
          :disabled="loadingDownloadButtons"
        >
          <span class="xls">
            <i class="fas fa-file-download"></i>
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import { mapState } from 'vuex';
import Paginate from 'vuejs-paginate';
import { format } from 'date-fns';
import swal from 'sweetalert';
import api from '@/services/api';
import GoBackButton from '@/components/atoms/goback-button';
import pt from 'date-fns/locale/pt';

export default {
  components: { GoBackButton, Paginate },

  data: () => ({
    actionDetailsStatus: null,
    actionDetailsSelected: null,
    actionDetailsOptions: [],
    limit: 10,
    actionDetailsItems: [],
    filter: null,
    userAuth: null,
    page: 1,
    total: null,
    loading: false,
    loadingDownloadButtons: false,
    fields: [],
    dataAction: null,
  }),

  watch: {
    myIh1: function watchMyIh1() {
      this.loadTableInfo();
    },
    myHierarchies1: function watchMyHierarchies1() {
      this.loadTableInfo();
    },
    myIh2: function watchMyIh2() {
      this.loadTableInfo();
    },
    myHierarchies2: function watchMyHierarchies2() {
      this.loadTableInfo();
    },
  },

  computed: {
    ...mapFields('actions', ['fromDetails']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('branches', [
      'myIh1',
      'myIh2',
      'myHierarchies1',
      'myHierarchies2',
    ]),
  },

  methods: {
    returnTranslateStatus(statusAction) {
      if (statusAction) {
        if (this.$i18n.locale === 'br') {
          let status = '';
          switch (statusAction) {
            case 'AGENDADO':
              status = 'AGENDADO';
              break;
            case 'PROCESSANDO':
              status = 'PROCESSANDO';
              break;
            case 'IMPORTANDO':
              status = 'IMPORTANDO';
              break;
            case 'IMPORTADO':
              status = 'IMPORTADO';
              break;
            case 'ENVIANDO':
              status = 'ENVIANDO';
              break;
            case 'ENVIADO':
              status = 'ENVIADO';
              break;
            case 'RESPONDIDO':
              status = 'RESPONDIDO';
              break;
            case 'QUARENTENA':
              status = 'QUARENTENA';
              break;
            case 'DUPLICADO':
              status = 'DUPLICADO';
              break;
            case 'BLOQUEADO':
              status = 'BLOQUEADO';
              break;
            case 'FALHA':
              status = 'FALHA';
              break;
            case 'IMPORTANDO':
              status = 'IMPORTANDO';
              break;
            case 'IMPORTADO':
              status = 'IMPORTADO';
              break;
            case 'CANCELADO':
              status = 'CANCELADO';
              break;
            default:
              status = '-';
          }

          return status;
        }

        if (this.$i18n.locale === 'us') {
          let status = '';
          switch (statusAction) {
            case 'AGENDADO':
              status = 'SCHEDULED';
              break;
            case 'PROCESSANDO':
              status = 'PROCESSING';
              break;
            case 'IMPORTANDO':
              status = 'IMPORTING';
              break;
            case 'IMPORTADO':
              status = 'IMPORTED';
              break;
            case 'ENVIANDO':
              status = 'SENDING';
              break;
            case 'ENVIADO':
              status = 'SENT';
              break;
            case 'RESPONDIDO':
              status = 'ANSWERED';
              break;
            case 'QUARENTENA':
              status = 'QUARANTINE';
              break;
            case 'DUPLICADO':
              status = 'DUPLICATE';
              break;
            case 'BLOQUEADO':
              status = 'BLOCKED';
              break;
            case 'FALHA':
              status = 'FAILED';
              break;
            case 'IMPORTANDO':
              status = 'IMPORTING';
              break;
            case 'IMPORTADO':
              status = 'IMPORTED';
              break;
            case 'CANCELADO':
              status = 'CANCELED';
              break;
            default:
              status = '-';
          }

          return status;
        }

        if (this.$i18n.locale === 'es') {
          let status = '';
          switch (statusAction) {
            case 'AGENDADO':
              status = 'PROGRAMADO';
              break;
            case 'PROCESSANDO':
              status = 'PROCESANDO';
              break;
            case 'IMPORTANDO':
              status = 'IMPORTANDO';
              break;
            case 'IMPORTADO':
              status = 'IMPORTADO';
              break;
            case 'ENVIANDO':
              status = 'ENVIANDO';
              break;
            case 'ENVIADO':
              status = 'ENVIADO';
              break;
            case 'RESPONDIDO':
              status = 'RESPONDIDO';
              break;
            case 'QUARENTENA':
              status = 'CUARENTENA';
              break;
            case 'DUPLICADO':
              status = 'DUPLICADO';
              break;
            case 'BLOQUEADO':
              status = 'BLOQUEADO';
              break;
            case 'FALHA':
              status = 'FALLIDO';
              break;
            case 'IMPORTANDO':
              status = 'IMPORTANDO';
              break;
            case 'IMPORTADO':
              status = 'IMPORTADO';
              break;
            case 'CANCELADO':
              status = 'CANCELADO';
              break;
            default:
              status = '-';
          }

          return status;
        }
      }

      return '-';
    },

    changeStatus() {
      if (this.actionDetailsStatus !== null) {
        this.loadTableInfo();
      }
    },

    searchByFilter() {
      if (this.filter !== '' && this.filter !== null) {
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(this.loadTableInfo, 600);
      }

      if (this.filter === '') {
        this.filter = null;
        this.page = 1;
        this.loadTableInfo();
      }
    },

    cleanFilter() {
      this.filter = null;
      this.loadTableInfo();
    },

    async download(type) {
      // checks if the total docs to download is greater then 100k
      if (this.total > 100000) {
        swal({
          title: this.$t('scheduling.messages.maxDownloadError.title'),
          text: this.$t('scheduling.messages.maxDownloadError.description'),
          icon: 'warning',
        });
        return;
      }
      this.loadingDownloadButtons = true;

      try {
        await api.get(`details/download/${this.$route.params.id}/${type}`, {
          headers: {
            'x-access-token': this.userAuth.token,
          },
          params: {
            filter: this.filter,
            startDate: this.calendarDates.start,
            endDate: this.calendarDates.end,
            ih1:
              this.myHierarchies1.length === 0
                ? null
                : this.myHierarchies1.join(','),
            ih2:
              this.myHierarchies2.length === 0
                ? null
                : this.myHierarchies2.join(','),
          },
        });

        swal({
          title: `${this.$t(
            'actionList.actionDetails.alertsActionDetails.succes.title',
          )}`,
          text: `${this.$t(
            'actionList.actionDetails.alertsActionDetails.succes.description',
          )}`,
          icon: 'success',
        });
      } catch (error) {
        swal({
          title: 'Oops...',
          text: error.response.data.message,
          icon: 'error',
        });
      }

      this.loadingDownloadButtons = false;
    },

    async loadTableInfo() {
      try {
        this.loading = true;
        const response = await api.get(
          `/action/details/${this.$route.params.id}`,
          {
            headers: { 'x-access-token': this.userAuth.token },
            params: {
              page: this.page,
              limit: this.limit,
              filter: this.filter,
              status: this.actionDetailsStatus,
              startDate: this.calendarDates.start,
              endDate: this.calendarDates.end,
              ih1:
                this.myHierarchies1.length === 0
                  ? null
                  : this.myHierarchies1.join(','),
              ih2:
                this.myHierarchies2.length === 0
                  ? null
                  : this.myHierarchies2.join(','),
            },
          },
        );
        this.actionDetailsItems = response.data.list;

        this.total = response.data.total;
        this.page = response.data.page;
        this.dataAction = response.data.action;
        this.loading = false;
      } catch (error) {
        swal({
          title: 'Oops...',
          text: error.response.data.message,
          icon: 'error',
        });
      }
    },

    dateFormat(param) {
      const date = format(param, 'dd/MM/yyyy HH:mm', { locale: pt });
      return date;
    },

    answerFormat(answer) {
      if (answer === true) {
        return this.$t('actionList.actionDetails.answered');
      }
      return this.$t('actionList.actionDetails.notAnswered');
    },

    verifyEmail(item) {
      if (item.validEmail) {
        return this.$t('actionList.actionDetails.valid');
      }
      return this.$t('actionList.actionDetails.invalid');
    },

    returnColorStatusPhone(isValidPhone) {
      if (isValidPhone) {
        return 'valido';
      }
      return 'invalido';
    },

    returnColorStatusEmail(isValidEmail) {
      if (isValidEmail) {
        return 'valido';
      }
      return 'invalido';
    },

    verifyPhone(item) {
      if (item.validPhone) {
        return this.$t('actionList.actionDetails.valid');
      }
      return this.$t('actionList.actionDetails.invalid');
    },

    setDifferenceInDays(date) {
      const time = new Date() - date.getTime();
      const difference = (time / (1000 * 3600 * 24)).toFixed(0);

      return difference;
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.fromDetails = true;
    this.loadTableInfo();
    this.fields = [
      {
        key: 'controlId',
        label: this.$t('actionList.actionDetails.labels.id'),
      },
      { key: 'name', label: this.$t('actionList.actionDetails.labels.name') },
      { key: 'email', label: this.$t('actionList.actionDetails.labels.email') },
      { key: 'phone', label: this.$t('actionList.actionDetails.labels.phone') },
      { key: 'date', label: this.$t('actionList.actionDetails.labels.date') },
      { key: 'days', label: this.$t('actionList.actionDetails.labels.days') },
      {
        key: 'channel',
        label: this.$t('actionList.actionDetails.labels.channel'),
      },
      {
        key: 'emailStatus',
        label: this.$t('actionList.actionDetails.labels.emailStatus'),
      },
      {
        key: 'phoneStatus',
        label: this.$t('actionList.actionDetails.labels.phoneStatus'),
      },
      {
        key: 'status',
        label: this.$t('actionList.actionDetails.labels.status'),
      },
    ];

    this.actionDetailsOptions = [
      {
        value: null,
        text: this.$t('actionList.actionDetails.actionFilterStatus.select'),
      },
      {
        value: 'all',
        text: this.$t('actionList.actionDetails.actionFilterStatus.all'),
      },
      {
        value: 'processando',
        text: this.$t(
          'actionList.actionDetails.actionFilterStatus.processando',
        ),
      },
      {
        value: 'importando',
        text: this.$t(
          'actionList.actionDetails.actionFilterStatus.importando',
        ),
      },
      {
        value: 'importado',
        text: this.$t(
          'actionList.actionDetails.actionFilterStatus.importado',
        ),
      },
      {
        value: 'enviando',
        text: this.$t('actionList.actionDetails.actionFilterStatus.enviando'),
      },
      {
        value: 'enviado',
        text: this.$t('actionList.actionDetails.actionFilterStatus.enviado'),
      },
      {
        value: 'respondido',
        text: this.$t('actionList.actionDetails.actionFilterStatus.respondido'),
      },
      {
        value: 'quarentena',
        text: this.$t('actionList.actionDetails.actionFilterStatus.quarentena'),
      },
      {
        value: 'duplicado',
        text: this.$t('actionList.actionDetails.actionFilterStatus.duplicado'),
      },
      {
        value: 'bloqueado',
        text: this.$t('actionList.actionDetails.actionFilterStatus.bloqueado'),
      },
      {
        value: 'falha',
        text: this.$t('actionList.actionDetails.actionFilterStatus.falha'),
      },
    ];
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
.body {
  background-color: $white;
  padding: 20px;
}

.body h2 {
  text-transform: uppercase;
  font-size: 21px;
  font-weight: 100;
  color: $gray;
}

.header-icon {
  float: left;
  font-size: 12px;
  margin-top: 4px;
  padding-right: 12px;
  color: $gray;
}

.flag-status {
  padding: 0.2rem;
  font-size: 0.8rem;
  border-radius: 0.25rem;
  color: $white;
  width: 100px;
  text-align: center;
}

.flag-status-valido {
  background-color: #28a745;
}

.flag-status-invalido {
  background-color: #dc3545;
}

.flag-status-enviado {
  background-color: #28a745;
}

.flag-status-respondido {
  background-color: #28a745;
}

.flag-status-quarentena {
  background-color: #ff9c07;
}

.flag-status-falha {
  background-color: #dc3545;
}

.flag-status-duplicado {
  background-color: #4635dc;
}

.flag-status-agendado {
  background-color: #ffc107;
}

.flag-status-bloqueado {
  background-color: #333333;
}

.flag-status-importando {
  background-color: #c1c1c1;
}

.flag-status-importado {
  background-color: #7045be;
}

.xls {
  font-size: 35px;
  color: $primary;
  cursor: pointer;
}

.xls:hover {
  color: #1dc86e;
}

.footer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.pagination-area-details >>> a {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #4ce595;
  background-color: #fff;
  border: 1px solid #dee2e6;
}
</style>

<style>
.pagination-area-details .active a {
  text-decoration: none;
  z-index: 1;
  color: #fff;
  background-color: #4ce595;
  border-color: #4ce595;
}

.pagination-area-details a {
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/action-list/action-list-details/index.vue